import axios from "axios";
import { BASE_URL_TADA_AYANA } from "../config";

export var TadaAyanaAPI = axios.create({
  baseURL: BASE_URL_TADA_AYANA
});
